import SectionSelection from "./SectionSelection";
import sectionsJson from "../data/selections/sectionDefinition.json";

const excludedByBase = (section, pathId) => {
  return !!section?.basesNotDisplayed?.includes(pathId)
}

const excludedByField = (section, fieldId) => {
  return !!section?.notDisplayedEachFieldChart && fieldId !== "00"
}

const excludedOnExternalServer = (section) => {
  return process.env.REACT_APP_IS_EXTERNAL && !!section?.notDisplayedOnExternalServer
}

const isExcludedSection = (section, pathId, fieldId) => {
  return excludedByBase(section, pathId) || excludedByField(section, fieldId) || excludedOnExternalServer(section)
}

// 学校種別（pathId）の選択状況に応じた節の一覧を返す
const filteredSections = (selectedState) => {
  const {
    pathId,
    fieldId,
    partId,
  } = selectedState
  const sections = sectionsJson[partId].sections
  return sections.filter(section =>
    !isExcludedSection(section, pathId, fieldId)
  )
}

const isPC = window.matchMedia('screen and (min-width: 640px)').matches

const sectionParentTexts = (sections) => {
  const rowLength = isPC ? 5 : 3
  let displayed = []
  return sections.map((s, i) => {
    if (i % rowLength === 0) { displayed = [] }
    if (!displayed.includes(s.parent)) {
      displayed.push(s.parent)
      return s.parent
    } else {
      return ''
    }
  })
}

function SectionSelectionsArea({ selectedState, onSelect = f => f }) {
  const activeSections = filteredSections(selectedState)
  const parentTexts = sectionParentTexts(activeSections)
  return (
    <div className="grid grid-cols-3 md:grid-cols-5 gap-x-0.5 my-2 md:mb-5 mx-2 md:mx-4">
      {
        activeSections.map((section, idx) => {
          return (
            <SectionSelection
              section={section}
              textAboveTheSection={parentTexts[idx]}
              isActive={selectedState.sectionId === section.id}
              selectedState={selectedState}
              onSelect={onSelect}
            />
          )
        })
      }
    </div>
  );
}

export default SectionSelectionsArea;
